'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import attdAction from '../../actions/attdAction';
import attdStore from '../../stores/attdStore';

class AllFilter extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {

            processing: attdStore.getState().processing,
            iniYear: 2017,
            iniMonth: 11,
            selectedYear: attdStore.getState().selectedYear,
            selectedMonth:  attdStore.getState().selectedMonth,
        };
    }
    static defaultProps = {
        mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }
    componentDidMount() {
        attdStore.listen(this.onChange);
    }
    componentWillUnmount() {
        attdStore.unlisten(this.onChange);
    }

    onChange(state) {
        this.setState({
            processing: state.processing,
            selectedYear: state.selectedYear,
            selectedMonth: state.selectedMonth,
           
        });
    }
    handleChange(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let value = e.target.value.split(":");
        let selectedYear = parseInt(value[0]);
        let selectedMonth = parseInt(value[1]);
        if (index == 0) {
            attdAction.selectedMonth({ selectedYear: selectedYear, selectedMonth: selectedMonth });

            if (!this.state.processing) {
                attdAction.processing(true);
                attdAction.getAllStaffAttendance(selectedYear, selectedMonth);
            }
        }

    }

   
    handleExport() {
        if (!this.state.processing) {
            attdAction.processing(true);
            attdAction.exportAllStaffAttendance(this.state.selectedYear, this.state.selectedMonth);
        }
    }
    handlePrint(){
        window.print(); 
    }
    renderOption(yr, mth) {
        let isSelected = yr == this.props.selectedYear && mth == this.props.selectedMonth ? true : false;
        return (<option value={yr + ":" + mth} key={yr + mth}>{this.props.mthTxt[mth] + " " + yr}</option>);
    }
    renderOptions() {
        let options = [];
        let thisYear = new Date().getFullYear();
        let thisMonth = new Date().getMonth();

        for (let yr = thisYear; yr >= this.state.iniYear; yr--) {
            if (thisYear == this.state.iniYear) {
                for (let mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else if (yr == thisYear) {
                for (let mth = thisMonth; mth >= 0; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else if (yr == this.state.iniYear) {
                for (let mth = 11; mth >= this.state.iniMonth; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else {
                for (let mth = 11; mth >= 0; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            }

        }
        return options;
    }
    render() {
        return (
            <div className="atd-i">
                <div className="row">
                    <div className="col-md-5 col-sm-5 col-lg-3">
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="startFrom" className="col-sm-4 control-label">Select Month: </label>
                            <div className="input-group input-group-sm">
                                <select className="form-control atd-sel" name="startFrom" data-index="0" onChange={this.handleChange} value={this.state.selectedYear + ":" + this.state.selectedMonth}>
                                    {this.renderOptions()}
                                </select>
                            </div>

                        </form>
                    </div>
                    <div className="col-md-4">
                        <div className="atd-i-btn">
                            <button className="btn btn-primary btn-sm" type="button" onClick={this.handlePrint}>Print</button>
                        </div>
                        <div className="atd-i-btn">
                            <button className="btn btn-primary btn-sm" onClick={this.handleExport}>Export</button>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default AllFilter;


// WEBPACK FOOTER //
// ./app/components/attdComponents/allFilter.js